import "../listSelect.css"
import {train} from "../../../data/selectOptions"
import { useState } from "react"
import ListSelect from "../ListSelect"
import Huns from "./TrainSelect/Huns"
import Egypts from "./TrainSelect/Egypts"
import Spartans from "./TrainSelect/Spartans"
import Gallic from "./TrainSelect/Gallic"
import Roman from "./TrainSelect/Roman"
import Teutonic from "./TrainSelect/Teutonic"

const TrainSelect =(props) => {

    const selectList = train 

    const [selectValue, setSelectValue] = useState("")
    const handleSelectValue = event => {
        setSelectValue(event.target.value)
    }

    function addItemHun (newItem) {
        props.addItem(newItem)
    }
    function addItemGal (newItem) {
        props.addItem(newItem)
    }
    function addItemTeutonic (newItem) {
        props.addItem(newItem)
    }
    function addItemRoman (newItem) {
        props.addItem(newItem)
    }
    function addItemEgypt (newItem) {
        props.addItem (newItem)
    }
    function addItemSpartan (newItem) {
        props.addItem (newItem)
    }

return (
    <div>
        <ListSelect label="...choose nation..." selectList={selectList} handleSelectValue={handleSelectValue} />
        {selectValue ==="1" ? (
            <Huns addItem={addItemHun} />
        ) :
        selectValue ==="2" ? (
            <Egypts addItem={addItemEgypt} />
        ) : 
        selectValue ==="3" ? (
            <Roman addItem={addItemRoman} />
        ) : 
        selectValue ==="4" ? (
            <Gallic addItem={addItemGal} />
        ) : 
        selectValue ==="5" ? (
            <Teutonic addItem={addItemTeutonic} />
        ) : 
        selectValue ==="6" ? (
            <Spartans addItem={addItemSpartan} />
        ) : null}
    </div>
    
    
)
}
export default TrainSelect